import { ThemeEvents } from '@theme/events';
import { Component } from '@theme/component';

/**
 * A custom element for the "Complete Your Routine" block.
 * Listens for variant update events and re-renders its inner content
 * from the updated section HTML, following the same pattern as ProductPrice.
 */
class BsCompleteYourRoutine extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
  }

  /**
   * Handles variant update events by replacing inner HTML with the
   * updated content from the re-rendered section HTML.
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    // Find the matching element in the new HTML by block ID
    const newElement = event.detail.data.html.querySelector(
      `bs-complete-your-routine[data-block-id="${this.dataset.blockId}"]`
    );
    if (!newElement) return;

    this.innerHTML = newElement.innerHTML;
  };
}

if (!customElements.get('bs-complete-your-routine')) {
  customElements.define('bs-complete-your-routine', BsCompleteYourRoutine);
}
